import React from 'react'

const MembershipCard = () => {
    return (
        <section className="w-full bg-gradient-radial py-12 lg:py-15 !pb-3 relative overflow-hidden" >
            <div className="container mx-auto px-4 lg:px-15 text-center">
                <h2 className="text-3xl sm:text-4xl lg:text-6xl font-bold font-urbanist text-white text-center sm:text-center">
                    Unlock Your Prestigious FWPI Membership
                </h2>
                <div className="flex flex-col lg:flex-row items-center justify-center relative">
                    <div className="flex flex-col items-center mt-8 py-5 md:py-20 md:px-10 sm:px-5">
                        <img className="w-full md:w-[85%] md:h-full lg:w-[85%] lg:h-full" src="/assets/facilities.png" alt="Choose membership type" />
                    </div>
                </div>
            </div>
        </section >
    )
}

export default MembershipCard